// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import french from './lang/fr'
import english from './lang/en'

Vue.config.productionTip = false
Vue.use(VueI18n)

let locale = navigator.language.split('-')[0]
console.log('Using locale:' + locale)
const i18n = new VueI18n({
  fallbackLocale: 'en-US',
  locale: locale,
  // eslint-disable-next-line
  messages: {
    'fr': french,
    'en': english
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js